import { render } from "./ResetPasswordOtp.vue?vue&type=template&id=7b944c20&scoped=true"
import script from "./ResetPasswordOtp.vue?vue&type=script&lang=js"
export * from "./ResetPasswordOtp.vue?vue&type=script&lang=js"

import "./ResetPasswordOtp.vue?vue&type=style&index=0&id=7b944c20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b944c20"]])

export default __exports__